import { ToolLink } from "@/lib/types/app";
import ToolGrid from "./ToolGrid";
import EmptyStateCard from "./EmptyStateCard";

interface ToolsSectionProps {
  tools: ToolLink[];
  bookmarks: string[];
  toggleBookmark: (id: string) => void;
  userIsPilot: boolean;
  filter: (tool: ToolLink) => boolean;
  emptyStateTitle: string;
  emptyStateDescription: string;
}

export default function ToolsSection({
  tools,
  bookmarks,
  toggleBookmark,
  userIsPilot,
  filter,
  emptyStateTitle,
  emptyStateDescription,
}: ToolsSectionProps) {
  const filteredTools = tools
    .filter(filter)
    .sort((a, b) => a.priority - b.priority);

  if (filteredTools.length === 0) {
    return (
      <div
        className="grid gap-6"
        style={{
          gridTemplateColumns: "repeat(auto-fill, minmax(auto, 350px))",
        }}
      >
        <EmptyStateCard
          title={emptyStateTitle}
          description={emptyStateDescription}
        />
      </div>
    );
  }

  return (
    <ToolGrid
      tools={filteredTools}
      bookmarks={bookmarks}
      toggleBookmark={toggleBookmark}
      userIsPilot={userIsPilot}
    />
  );
}
